export default "__VITE_ASSET__IFp2B3PQ__"